import { useNavigate } from 'react-router-dom';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import DiscoverBackButton from './components/discoverBackButton/DiscoverBackButton';
import DiscoverFeed from './components/discoverFeed/DiscoverFeed';
import DiscoverSkeleton from './components/discoverSkeleton/DiscoverSkeleton';
import { DiscoverView } from './discover.styles';
import { useDiscoverPersons } from './hooks/useDiscoverPersons';

const Discover = () => {
	const navigate = useNavigate();
	const t = useLanguageData('discover');
	const { isGuest, openAuthModal } = useGuestAuth();
	const { persons, isLoading } = useDiscoverPersons();

	const handleBack = () => {
		navigate('/');
	};

	const handleSelectProfile = (profile) => {
		if (isGuest) {
			openAuthModal('register');
			return;
		}

		navigate(`/chat/${profile._id}`);
	};

	return (
		<DiscoverView id="discoverView" data-view="discover">
			<DiscoverBackButton onClick={handleBack} ariaLabel={t.back} />
			{isLoading ? (
				<DiscoverSkeleton />
			) : (
				<DiscoverFeed persons={persons} onSelectProfile={handleSelectProfile} />
			)}
		</DiscoverView>
	);
};

export default Discover;
